import { createStore } from "vuex";

interface State {
	version: string;
	activeLanguage: string;
	languages: string[];
	tutorialVisible: boolean;
	firstTimeTutorial: boolean;
	activeTutorialPage: number;
	availableSegments: any; // TODO: Replace with the correct type
	waterEnabled: boolean;
	sewageEnabled: boolean;
	gasEnabled: boolean;
	isInfoPanelOpen: boolean;
	infoPanelData: any; // TODO: Replace with the correct type
	isTooltipOpen: boolean;
	tooltipData: any; // TODO: Replace with the correct type
	toolTipsDisabled: boolean;
	products: any[]; // TODO: Replace with the correct type
	isGround1Open: boolean;
	isGround2Open: boolean;
	isWorldLoaded: boolean;
	loadingscreenVisible: boolean;
	defaultCamStats: {
		radius: {
			upperLimit: number | null;
			lowerLimit: number | null;
			value: number | null;
		};
		alpha: {
			upperLimit: number | null;
			lowerLimit: number | null;
			value: number | null;
		};
		beta: {
			upperLimit: number | null;
			lowerLimit: number | null;
			value: number | null;
		};
		target: any; // TODO: Replace with the correct type
	};
}

export default createStore<State>({
	state: {
		version: "1.0.0",
		versionData: null,
		activeLanguage: 'de',
		languages: ['de'],
		tutorialVisible: false,
		firstTimeTutorial: true,
		activeTutorialPage: 0,
		availableSegments: null,
		waterEnabled: true,
		sewageEnabled: true,
		gasEnabled: true,
		isInfoPanelOpen: false,
		infoPanelData: null,
		isTooltipOpen: false,
		tooltipData: null,
		toolTipsDisabled: true,
		products: [],
		activeAreaID: null,
		isWorldLoaded: false,
		loadingscreenVisible: true,
		defaultCamStats: {
			radius: {
				upperLimit: null,
				lowerLimit: null,
				value: null,
			},
			alpha: {
				upperLimit: null,
				lowerLimit: null,
				value: null,
			},
			beta: {
				upperLimit: null,
				lowerLimit: null,
				value: null,
			},
			target: null,
		}
	},
	getters: {
		version: (state) => { return state.version; },
		versionData: (state) => { return state.versionData; },
		toolTipsDisabled: (state) => { return state.toolTipsDisabled; },
		tooltipData: (state) => { return state.tooltipData; },
		loadingscreenVisible: (state) => { return state.loadingscreenVisible; },
		activeLanguage: (state) => {return state.activeLanguage},
		languages: (state) => {return state.languages},
		products: (state) => {return state.products},
		availableSegments: (state) => {return state.availableSegments},
		isWaterEnabled: (state) => {return state.waterEnabled},
		isSewageEnabled: (state) => {return state.sewageEnabled},
		isGasEnabled: (state) => {return state.gasEnabled},
		activeAreaID: (state) => {return state.activeAreaID},
		isWorldLoaded: (state) => {return state.isWorldLoaded},
		isInfoPanelOpen: (state) => {return state.isInfoPanelOpen},
		isTooltipOpen: (state) => {return state.isTooltipOpen},
		defaultCamStats: (state) => {return state.defaultCamStats},
		infoPanelData: (state) => {return state.infoPanelData},
		isTutorialVisible: (state) => {return state.tutorialVisible},
		isFirstTimeTutorial: (state) => {return state.firstTimeTutorial},
	},
	mutations: {
		setVersion(state, version: string){
			state.version = version;
		},
		setVersionData(state, data: any){
			state.versionData = data;
		},
		setToolTipsDisabled(state, boolean: boolean){
			console.log((boolean ? "Disable" : "Enable") + " Tooltips");
			state.toolTipsDisabled = boolean;
		},
		setLoadingscreenVisible(state, boolean: boolean){
			state.loadingscreenVisible = boolean;
		},
		setActiveLanguage(state, code: string){
			state.activeLanguage = code;
		},
		setProducts(state, array: any[]){
			state.products = array;
		},
		setLanguages(state, array: string[]){
			state.languages = array;
		},
		setAvailableSegments(state, object: any){
			state.availableSegments = object;
		},
		setWaterBool(state, boolean: boolean){
			state.waterEnabled = boolean;
		},
		setSewageBool(state, boolean: boolean){
			state.sewageEnabled = boolean;
		},
		setGasBool(state, boolean: boolean){
			state.gasEnabled = boolean;
		},
		setActiveAreaID(state, id: number){
			state.activeAreaID = id;
		},
		toggleWaterBool(state){
			state.waterEnabled = !state.waterEnabled;
		},
		toggleSewageBool(state){
			state.sewageEnabled = !state.sewageEnabled;
		},
		toggleGasBool(state){
			state.gasEnabled = !state.gasEnabled;
		},
		setDefaultCamTarget(state, target: any){
			state.defaultCamStats.target = target;
		},
		setDefaultCamStats(state, camStats: any){
			state.defaultCamStats = camStats;
		},
		setInfoPanelOpen(state, boolean: boolean){
			state.isInfoPanelOpen = boolean;
		},
		setTooltipOpen(state, boolean: boolean){
			state.isTooltipOpen = boolean;
		},
		setTooltipData(state, data: any){
			state.tooltipData = data;
		},
		setInfoPanelData(state, data: any){
			state.infoPanelData = data;
		},
		setTutorialVisible(state, boolean: boolean){
			state.tutorialVisible = boolean;
		},
		setFirstTimeTutorialBoolean(state, boolean: boolean){
			state.firstTimeTutorial = boolean;
		},
		setWorldLoaded(state, boolean: boolean){
			state.isWorldLoaded = boolean;
		},
	}
})